import detect from '@iqiyi-kpp/utility/es/detector'

function getRightPicSize(url, param = '690_388') {
  if (!url) {
    return ''
  }
  const origin = url.slice(0, url.length - 4)
  const extend = url.slice(url.length - 1 - 3, url.length)
  return `${origin}_${param}${extend}`
}
function getImgUrl(imgItem, param = '480_270') {
  if (!imgItem) {
    return ''
  }
  if (imgItem.appointImageUrl) {
    return imgItem.appointImageUrl
  }
  if (imgItem.sourceImageUrl) {
    return getRightPicSize(imgItem.sourceImageUrl, param)
  }
  return ''
}
function getRightPrice(priceItem, type = 'discountPrice') {
  if (type === 'discountPrice') {
    if (priceItem.discountPrice) {
      return (parseFloat(priceItem.discountPrice) / 100).toFixed(2)
    }
    if (priceItem.originPrice) {
      return (parseFloat(priceItem.originPrice) / 100).toFixed(2)
    }
    return ''
  }
  if (type === 'originPrice') {
    return priceItem.originPrice ? (parseFloat(priceItem.originPrice) / 100).toFixed(2) : ''
  }
  return null
}

/**
 * 获取注册制参数
 *
 */
const getRegisterParam = (subId, dynamic, others) => {
  return {
    biz_id: '14', // 知识付费业务id
    biz_params: {
      biz_dynamic_params: dynamic, // 运营动态投放或者基线接口动态组装，比如bookid，h5url的具体值或者参数的组合，以&链接
      biz_extend_params: '', // 扩展参数，由各个业务线自己定义，方便以后扩展。接口或者app不做修改
      biz_params: '', // 子业务静态参数，一般不变
      biz_statistics: others, // 统计相关带入参数
      biz_sub_id: subId // 子业务id，各个垂线业务自己定义
    },
    biz_plugin: 'com.iqiyi.knowledge' // 业务安卓包名， 只对安卓插件中心有效，从985开始iOS同样改为必运动会参数
  }
}
function getSchemaUrlParams(bizParamStr) {
  if (detect.iqiyi()) {
    return `iqiyi://mobile/register_business/com_iqiyi_knowledge?pluginParams=${encodeURIComponent(
      encodeURIComponent(bizParamStr)
    )}`
  }
  return `knowledge://mobile/register_business/com_iqiyi_knowledge?pluginParams=${encodeURIComponent(
    encodeURIComponent(bizParamStr)
  )}`
}
function getPluginRegisterParam(item, channel, rpage) {
  let openColumnOrLessonParam
  if (item.qipuType === 'COLUMN') {
    openColumnOrLessonParam = getRegisterParam(6, `id=${item.id}`, `channel=${channel}&s2=${rpage}`)
  } else {
    openColumnOrLessonParam = getRegisterParam(7, `id=${item.id}`, `channel=${channel}&s2=${rpage}`)
  }
  return openColumnOrLessonParam
}
function callAPP(item, channel, rpage) {
  if (!item || !rpage) {
    return
  }
  const bizParam = getPluginRegisterParam(item, channel, rpage)
  const bizParamStr = JSON.stringify(bizParam)
  // 将shema存在全局，方便其他函数使用
  // window.schema = schema
  const schemaUrl = getSchemaUrlParams(bizParamStr)
  if (detect.iqiyi() || detect.zhishi()) {
    location.href = schemaUrl
  } else {
    location.href = `http://zhishi.m.iqiyi.com/column?columnId=${item.id}&social_platform=${channel}`
  }
}
export default {
  install(Vue) {
    Vue.prototype.$getImgUrl = getImgUrl
    Vue.prototype.$getRightPrice = getRightPrice
    Vue.prototype.$callAPP = callAPP
  }
}
